<div class="contact-content">
    <div class="back-button">
        <mat-icon routerLink="/doctor/{{ originalRouterLink }}">arrow_back</mat-icon>
    </div>
    <div>
        <h3>{{ doctor.name! | uppercase }} - KONZULTÁCIÓS IDŐ</h3>
    </div>
    <h3>Jelenlegi konzultációs idők</h3>
    @for (consultationHour of doctorConsultingHoursList; track consultationHour; let i = $index) {
    <div class="array" [ngStyle]="{ 'margin-bottom': '32px' }">
        <div class="form-element"
            [ngStyle]="i % 2 === 0 ? { background: 'white', display: 'flex' } : { background: '#efeff5', display: 'flex' }">
            <div class="field-container">
                <div class="field">
                    <span>Konzultáció napja</span>
                    <div class="data">
                        <input placeholder="{{ consultationHour.day }}" type="text" disabled />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Konzultáció kezdete</span>
                    @if (consultationHour.startTime !== null) {
                    <div class="data">
                        <input placeholder="{{ consultationHour.startTime }}" type="text" disabled />
                    </div>
                    }
                    @if (consultationHour.startTime === null) {
                    <div class="data">
                        <input disabled placeholder="változó" />
                    </div>
                    }
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Konzultáció vége</span>
                    @if (consultationHour.endTime !== null) {
                    <div class="data">
                        <input type="text" disabled [placeholder]="consultationHour.endTime" />
                    </div>
                    }
                    @if (consultationHour.endTime === null) {
                    <div class="data">
                        <input type="text" disabled placeholder="változó" />
                    </div>
                    }
                </div>
                <mat-icon [ngStyle]="{ cursor: 'pointer' }"
                    (click)="openDeleteConsultingDialog(consultationHour.id!)">delete_forever</mat-icon>
            </div>
        </div>
    </div>
    }
    <h3>Új konzultációs idő hozzáadása</h3>
    <div class="contact-form">
        <form novalidate [formGroup]="consultationHourForm!">
            <div class="field-container">
                <div class="field">
                    <span>Konzultáció napja</span>
                    <div class="data">
                        <input formControlName="day" id="day" class="form-control" type="text" required
                            [(ngModel)]="doctorConsultingHour.day" />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Konzultáció kezdete</span>
                    <div class="data">
                        <mat-timepicker />
                        <input formControlName="startTime" id="startTime" class="form-control" type="time" required
                            [(ngModel)]="doctorConsultingHour.startTime" />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Konzultáció vége</span>
                    <div class="data">
                        <input formControlName="endTime" id="endTime" class="form-control" type="time" required
                            [(ngModel)]="doctorConsultingHour.endTime" />
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="field-container" [ngStyle]="{ 'margin-top': '8px' }">
        <div class="field" [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }">
            <div class="data" [ngStyle]="{ 'justify-content': 'center' }">
                <button
                    [ngStyle]="{ background: '#eee', border: '1px solid #0E8388', 'font-weight': 'bold', width: '100%' }"
                    [disabled]="!consultationHourForm?.valid" (click)="addConsultationHour()">
                    KONZULTÁCIÓS IDŐ MENTÉSE
                </button>
            </div>
        </div>
    </div>
</div>